<template>
	<div>
		<Loader />
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  created () {
    Vue.api.get('/search/customer?term=' + this.$route.params.email, {}, {
      callback: (data) => {
        if (!data.url) {
          alert('Customer not found')
        } else {
          this.$router.push(data.url)
        }
      }
    })
  }
}
</script>
